import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/services/admin/admin.service';
import { LanguagesService } from 'src/app/services/languages/languages.service';

@Component({
  selector: 'app-seand',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule
  ],
  templateUrl: './seand.component.html',
  styleUrl: './seand.component.css'
})
export class SeandComponent {

  @Input() email = ''
  load = false

  selectedLanguage: any

  constructor(
    private AdminService: AdminService,
    private ToastrService: ToastrService,
    private translate: TranslateService,
    private languageService: LanguagesService
  ){

    this.languageService.selectedLanguage$.subscribe(
      (lang: any) => {this.selectedLanguage = lang}
    );



  }

  seand()
  {
    const data = {
      email: this.email,
      lang: this.selectedLanguage.code
    }
    this.load = true
    this.AdminService.seandVerifyLinkEmail(data).subscribe(
      (res: any) => {
        // console.log(res)
        this.load = false
        this.ToastrService.success(this.translate.instant('VERIFY_LINK_SENT'));
      },
      (error: any) => {
        // console.log(error)
        this.load = false
        this.ToastrService.error(this.translate.instant('VERIFY_LINK_ERROR'));
      }
    )
  }
}
